import { Component } from 'react';

import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import CumulativeWeeklyDataChart from '../../../../components/Charts/CumulativeWeeklyDataChart';
import chartsGuide from '../../../../utils/charts/charts_guide.json';


// https://apexcharts.com/react-chart-demos/line-charts/brush-chart/
// https://apexcharts.com/react-chart-demos/area-charts/github-style/

// TODO : Missing bar for cumulative

interface Props {
    loading: boolean
    data?: any
}
interface State {
}

export default class WeeklyStatistics extends Component<Props, State>{


    render() {
        return (
            <div className="ingestion-statistics">
                <div className="date-charts">
                    {
                        this.props.loading ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.props.data ?
                                <>

                                    <CumulativeWeeklyDataChart
                                        title="Archived products size" 
                                        data={this.props.data.week[0]}
                                        size
                                        chartData={chartsGuide.bar_chart}
                                    />

                                    <CumulativeWeeklyDataChart
                                        title="Archived products number" 
                                        data={this.props.data.week[1]}
                                        chartData={chartsGuide.bar_chart}
                                    />
                                </> 
                                :
                                <div className="no-data">No data</div>
                    }
                </div>
            </div>
        );
    }

};
